import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild('navbarToggler') navbarToggler:ElementRef;
  language:string;
  show:string;
  bgColor = "linear-gradient(to bottom, rgba(0,0,0,1) 0%,transparent 100%)";
  constructor(private translate: TranslateService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.language = this.translate.currentLang;
    });
  }

  ngOnInit(): void {
  }
  navBarTogglerIsVisible() {
    return this.navbarToggler.nativeElement.offsetParent !== null;
  }
  collapseNav() {
    if (this.navBarTogglerIsVisible()) {
      this.navbarToggler.nativeElement.click();
      // this.changeColor();
    }
  }
    changeColor(){
      if (this.bgColor !=  "#000000") {
        this.bgColor = "#000000";
        this.show = 'show';
      }else{
        this.bgColor = "linear-gradient(to bottom, rgba(0,0,0,1) 0%,transparent 100%)";
        this.show = '';
      }
    }
    // Se cambia el idioma a Español
    changeLanguageToSpanish(): void {
      this.translate.use('es');
      console.log('En español');
    }

    // Se cambia el idioma a Inglés
    changeLanguageToEnglish(): void {
      this.translate.use('en');
      console.log('In English');
    }
}
